// import { BACKEND_FIELD_MAP } from "../config/payloadMap";

// export function buildSubmitPayload(values, status = "draft") {
//   const passenger = {};

//   // Map frontend → backend fields
//   Object.entries(BACKEND_FIELD_MAP).forEach(
//     ([frontendKey, backendKey]) => {
//       let value = values[frontendKey];

//       // Normalize undefined/null
//       if (value === undefined || value === null) {
//         value = "";
//       }

//       // Normalize booleans coming from radio Yes/No
//       if (value === "Yes") value = "Yes";
//       if (value === "No") value = "No";

//       passenger[backendKey] = value;
//     }
//   );

//   return {
//     passengers: [passenger],
//     status,
//   };
// }


import { BACKEND_FIELD_MAP } from "../config/payloadMap";

export function buildSubmitPayload(values, status = "draft") {
  const passenger = {};

  // Map frontend → backend fields
  Object.entries(BACKEND_FIELD_MAP).forEach(
    ([frontendKey, backendKey]) => {
      let value = values[frontendKey];

      // Normalize undefined/null
      if (value === undefined || value === null) {
        value = "";
      }

      // Normalize booleans coming from radio Yes/No
      if (value === "Yes") value = "Yes";
      if (value === "No") value = "No";

      passenger[backendKey] = value;
    }
  );

  // ✅ Handle SAARC visits array separately
  if (values.saarc_visits && Array.isArray(values.saarc_visits)) {
    // Remove the old single-value SAARC fields from passenger object
    delete passenger.saarc_country;
    delete passenger.saarc_year;
    delete passenger.no_of_visits;

    // Add the array of SAARC visits
    passenger.saarc_visits = values.saarc_visits.map(visit => ({
      saarc_country: visit.saarc_country || "",
      saarc_year: visit.saarc_year || "",
      no_of_visits: visit.no_of_visits || ""
    }));
  }

  return {
    passengers: [passenger],
    status,
  };
}